<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          Setar Senha
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation v-model="valid">
            <v-text-field
              v-if="usuario"
              type="password"
              label="Senha Atual"
              v-model="senhaAtual"
              prepend-icon="lock"
              :rules="[rules.required, rules.minLen]"
              @keyup.enter="adiciona"
            ></v-text-field>
            <v-text-field
              type="password"
              label="Senha"
              v-model="senha"
              prepend-icon="lock"
              :rules="[rules.required, rules.minLen]"
              @keyup.enter="adiciona"
            ></v-text-field>
            <v-text-field
              type="password"
              label="Confirme a Senha"
              v-model="confirmeSenha"
              prepend-icon="lock"
              :rules="[rules.senhaIgual]"
              @keyup.enter="adiciona"
            ></v-text-field>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: 'ModalSetaSenha',
  props: ["value", "usuario", "loading"],
  data() {
    return {
      valid: true,
      senha: '',
      senhaAtual: '',
      confirmeSenha: '',
      rules: {
        required: value => !!value || 'Campo obrigatório.',
        minLen: value => value && value.length >= 6 || 'Mínimo 6 caracteres.',
        senhaIgual: value => !!value && value == this.senha || 'Senha difere da senha digitada.'
      }
    };
  },
  methods: {
    ...mapMutations(["showNotification"]),
    ...mapActions(["setaSenhaUsuario"]),
    adiciona() {
      if (this.$refs.form.validate()) {
        if (this.usuario) {
          this.$emit('setaSenhaSelected', { senhaAtual: this.senhaAtual, novaSenha: this.senha });
        } else {
          this.$emit('setaSenhaSelected', this.senha);
        }
      } else {
        this.showNotification({ text: 'Informe a senha.', status: 'error' });
      }
    }
  },
};
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1rem !important;
  }
}
</style>
